import { numberFormatUtils } from '@instinet-analytics/core-lib';
import { baseNumberComparator } from '@instinet-analytics/core-lib';
import Column, { getBaseColumn } from './Column';
import ColumnType from './ColumnType';
import SortType from './SortType';

const { N2 } = numberFormatUtils;

const basePriceColumn: Partial<Column<ColumnType.PRICE>> = {
    ...getBaseColumn(ColumnType.PRICE),
    sortCompareFunction: baseNumberComparator,
    textAlign: 'right',
    colFmt: N2,
};

export const arrivalP = {
    ...basePriceColumn,
    name: 'Arrival',
    dataField: 'arrivalP',
    width: 75,
    tag: 'Order Data/Arrival Price',
    desc: 'Arrival price',
    defaultSortDesc: true,
    sortType: SortType.BLANK,
};

export const avgPx = {
    ...basePriceColumn,
    name: 'Avg Px',
    dataField: 'avgPx',
    width: 75,
    tag: 'Order Data/Avg Px',
    desc: 'Average price (local currency)',
    defaultSortDesc: true,
    sortType: SortType.BLANK,
};

export const limit = {
    ...basePriceColumn,
    name: 'Limit',
    dataField: 'limit',
    width: 75,
    tag: 'Order Data/Limit',
    desc: 'Limit price',
};

export const pnc = {
    ...basePriceColumn,
    name: 'PNC',
    dataField: 'pnc',
    width: 70,
    tag: 'Market Data/PNC',
    desc: "Previous night's close (local currency)",
};

export const lastPrice = {
    ...basePriceColumn,
    name: 'Last Price',
    dataField: 'lp',
    width: 70,
    tag: 'Market Data/Last Price',
    desc: 'Last Price (local currency)',
};
